import pickup from './endpoints/pickUp';
import forecastByDay from './endpoints/forecastByDay';
import forecastByMonth from './endpoints/forecastByMonth';
import budgetByDay from './endpoints/budgetByDay';
import budgetByMonth from './endpoints/budgetByMonth';
import businessAnalysis from './endpoints/businessAnalysis';
import businessAnalysisByRoomType from './endpoints/businessAnalysisByRoomType';
import overnightStats from './endpoints/overnightStats';
import currentRoomsRevenueByDay from './endpoints/currentRoomsRevenueByDay';
import lyFinalRoomsRevenueByDay from './endpoints/lyFinalRoomsRevenueByDay';
import lySpitRoomsRevenueByDay from './endpoints/lySpitRoomsRevenueByDay';
import lySpitRoomsRevenueByMonth from './endpoints/lySpitRoomsRevenueByMonth';
import y2FinalRoomsRevenueByDay from './endpoints/y2FinalRoomsRevenueByDay';
import y2SpitRoomsRevenueByDay from './endpoints/y2SpitRoomsRevenueByDay';
import statisticsByDay from './endpoints/statisticsByDay';
import commissionByPeriod from './endpoints/commissionByPeriod';
import lyFinalCommissionByPeriod from './endpoints/lyFinalCommissionByPeriod';
import lySpitCommissionByPeriod from './endpoints/lySpitCommissionByPeriod';
import businessChangeByMonth from './endpoints/businessChangeByMonth';
import businessChangeByDay from './endpoints/businessChangeByDay';
import recommendationRevenueGain from './endpoints/recommendationRevenueGain';
import inventoryBlocks from './endpoints/inventoryBlocks';
import cancellationReportTransientBusiness from './endpoints/cancellationReportTransientBusiness';
import bookings from './endpoints/bookings';
import vendorOauth from './endpoints/vendorOauth';
import fiscalPeriods from './endpoints/fiscalPeriods';
import recommendationsCountByMonth from './endpoints/recommendationsCountByMonth';
import roomRecommendationsCountByMonth from './endpoints/roomRecommendationsCountByMonth';
import roomRecommendationsCountByDay from './endpoints/roomRecommendationsCountByDay';
import adminPropertyList from './endpoints/adminPropertyList';
import adminFeatureList from './endpoints/adminFeatureList';
import deletePropertyCache from './endpoints/adminDeletePropertyCache';
import roomTypes from './endpoints/roomTypes';
import sellingRate from './endpoints/sellingRate';
import hurdleRackRates from './endpoints/hurdleRackRates';
import inventoryBlocksMonthly from './endpoints/inventoryBlocksMonthly';
import otaInsightsDailyWithChange from './endpoints/otaInsightsDailyWithChange';

export default [
    pickup.saga,
    forecastByDay.saga,
    forecastByMonth.saga,
    budgetByDay.saga,
    budgetByMonth.saga,
    businessAnalysis.saga,
    businessAnalysisByRoomType.saga,
    overnightStats.saga,
    currentRoomsRevenueByDay.saga,
    lyFinalRoomsRevenueByDay.saga,
    lySpitRoomsRevenueByDay.saga,
    lySpitRoomsRevenueByMonth.saga,
    y2FinalRoomsRevenueByDay.saga,
    y2SpitRoomsRevenueByDay.saga,
    statisticsByDay.saga,
    commissionByPeriod.saga,
    lyFinalCommissionByPeriod.saga,
    lySpitCommissionByPeriod.saga,
    businessChangeByMonth.saga,
    businessChangeByDay.saga,
    recommendationRevenueGain.saga,
    inventoryBlocks.saga,
    cancellationReportTransientBusiness.saga,
    bookings.saga,
    vendorOauth.saga,
    fiscalPeriods.saga,
    recommendationsCountByMonth.saga,
    roomRecommendationsCountByMonth.saga,
    roomRecommendationsCountByDay.saga,
    adminPropertyList.saga,
    adminFeatureList.saga,
    deletePropertyCache.saga,
    roomTypes.saga,
    sellingRate.saga,
    hurdleRackRates.saga,
    inventoryBlocksMonthly.saga,
    otaInsightsDailyWithChange.saga,
];
